import React from 'react';
import Header from './components/Header';
import Main from './pages/Main';

import logo from './assets/images/HiDe_transparent.png';
import './assets/css/Main.css';

function App() {
  return (
    <div className="wrapper">
      <Header isLogoImg={false} title="HiDe" img={logo} />
      <Main />
    </div>
  );
}

export default App;
